/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ClassroomdisciplineIdMaterials200,
  GetApiV1ClassroomdisciplineIdMaterials401,
  GetApiV1ClassroomdisciplineIdMaterials404,
  GetApiV1ClassroomdisciplineIdMaterialsPathParams,
  GetApiV1ClassroomdisciplineIdMaterialsQueryParams,
  GetApiV1ClassroomdisciplineIdMaterialsQueryResponse,
} from "../../types/classPlanningMaterialController/GetApiV1ClassroomdisciplineIdMaterials.ts";
import { materialItemViewModelSchema } from "../materialItemViewModelSchema.ts";

export const getApiV1ClassroomdisciplineIdMaterialsPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1ClassroomdisciplineIdMaterialsPathParams>;

export const getApiV1ClassroomdisciplineIdMaterialsQueryParamsSchema = z
  .object({
    parentFolderId: z.optional(z.coerce.number().int()),
    culture: z.optional(z.string()),
  })
  .optional() as unknown as ToZod<GetApiV1ClassroomdisciplineIdMaterialsQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ClassroomdisciplineIdMaterials200Schema = z.array(
  z.lazy(() => materialItemViewModelSchema),
) as unknown as ToZod<GetApiV1ClassroomdisciplineIdMaterials200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ClassroomdisciplineIdMaterials401Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineIdMaterials401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1ClassroomdisciplineIdMaterials404Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineIdMaterials404>;

export const getApiV1ClassroomdisciplineIdMaterialsQueryResponseSchema = z.lazy(
  () => getApiV1ClassroomdisciplineIdMaterials200Schema,
) as unknown as ToZod<GetApiV1ClassroomdisciplineIdMaterialsQueryResponse>;
